(function () {
  'use strict';

  /* @ngdoc object
   * @name neo.home.statistics.entities
   * @description
   *
   */
  angular
    .module('neo.home.statistics.entities', [
      'ui.router'
    ]);
}());
